import { GridColDef } from "@mui/x-data-grid";
import { IconButton } from "@mui/material"; 
import ItemStatus from "../../../../../../common/components/item_status";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import LargeItemStatus from "../../../../../../common/components/large_item_status";

type AllowedColors = "green" | "red" | "blue" | "yellow" | "gray";

interface StatusProps {
  title: string;
  color: AllowedColors;
  description: string;
}

interface Props {
  onActionEditar: (id: number, open: boolean) => void;
  onActionDeletar: (id: number, open: boolean) => void;
}

export const GenerateFuncionariosTercerizacaoColumns = ({
  onActionEditar, onActionDeletar
}: Props): GridColDef[] => {


  const getStatusProps = (status: boolean): StatusProps => {
    switch (status) {
      case false: 
        return { title: "I", color: "gray", description: "Inativo" };
      case true: 
        return { title: "A", color: "blue", description: "Ativo" };
      default:
        return { title: "?", color: "gray", description: "Desconhecido" };
    }
  };

  const getAsoProps = (aso: number): StatusProps => {
  switch (aso) {
    case 0:
      return { title: "Sim", color: "blue", description: "Sim" };
    case 1:
      return { title: "Não", color: "red", description: "Não" };
    case 2:
      return { title: "NA", color: "gray", description: "Não Se Aplica" };
    default:
      return { title: "NA", color: "gray", description: "Não Se Aplica" };
  }
};
  const getDocumentosProps = (doc: string): StatusProps => {
    switch (doc) {
      case "ND": 
        return { title: "ND", color: "yellow", description: "Não possui Documentos" };
      case "DE": 
        return { title: "DE", color: "blue", description: "Documentos Em Dia" };
      case "DV": 
        return { title: "DV", color: "red", description: " Documentos Vencidos" };
      default:
        return { title: "?", color: "gray", description: "Desconhecido" };
    }
  };

  const getTreinamentoProps = (treina: string): StatusProps => {
    switch (treina) {
      case "NT": 
        return { title: "NT", color: "gray", description: "Não possui treinamentos" };
      case "AT": 
        return { title: "AT", color: "red", description: "Avaliação de treinamentos em atraso" };
      case "AC": 
        return { title: "AC", color: "blue", description: "Avaliação de treinamentos concluídas" };
      case "TNR": 
        return { title: "TNR", color: "yellow", description: "Treinamentos não realizados" };
      default:
        return { title: "?", color: "gray", description: "Desconhecido" };
    }
  };


  return [
    {
      field: "Ativo",
      headerName: "Status",
      width: 90,
      filterable: false,
      sortable: false,
      renderCell: (params) => {
        const { title, color, description } = getStatusProps(params.value);
        return (
          <div className="w-full h-full flex justify-center items-center">
            <ItemStatus title={title} color={color} description={description} />
          </div>
        );
      }
    },
    {
      field: "StatusAso", 
      headerName: "ASO OK?",
      width: 90, 
      filterable: false,
      sortable: false,
      renderCell: (params) => {
        const { title, color, description } = getAsoProps(params.value);
        return (
          <div className="w-full h-full flex justify-center items-center">
            <LargeItemStatus title={title} color={color} description={description} /> 
          </div>
        );
      }
    },
    {
      field: "Documentos",
      headerName: "Docs",
      width: 80, 
      filterable: false,
      sortable: false,
      renderCell: (params) => {
        const { title, color, description } = getDocumentosProps(params.value);
        return (
          <div className="w-full h-full flex justify-center items-center">
            <LargeItemStatus title={title} color={color} description={description} /> 
          </div>
        );
      }
    },
    {
      field: "Treinamentos",
      headerName: "Treinamentos",
      width: 130, 
      renderCell: (params) => {
        const { title, color, description } = getTreinamentoProps(params.value);
        return (
          <div className="w-full h-full flex justify-center items-center">
            <LargeItemStatus title={title} color={color} description={description} /> 
          </div>
        );
      }
    },
    {
      field: "Nome",
      headerName: "Nome",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        return (<div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>);
      },
    },
    {
      field: "NomeCargo",
      headerName: "Cargo",
      flex: 1,
      minWidth: 200,
      renderCell: (params) => {
        return (<div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>);
      },
    },
    {
      field: "NomeFornecedor",
      headerName: "Fornecedor",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        return (<div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>);
      },
    },
    {
      field: "NomeCentroCusto",
      headerName: "Centro de Custo",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        return (<div className="break-normal w-full h-full flex justify-start items-center text-left text-xs py-2 px-2">
          <span>{params.value}</span>
        </div>);
      },
    },
    {
      field: 'IdFuncionarioTerc',
      headerName: 'Ações',
      sortable: false,
      filterable: false,
      width: 100, 
      renderCell: (params) => (
        <div className="flex items-center justify-center w-full h-full gap-2">
          <IconButton onClick={() => onActionEditar(params.value, true)} title="Editar">
            <DynamicIcon nameIcon="EditRounded" size={20} className="text-blue-500" />
          </IconButton>
          <IconButton onClick={() => onActionDeletar(params.value, true)} title="Editar">
             <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
          </IconButton>
        </div>
      ),
    },
  ];
}